import AudioPlayer from "../../common/audio-player/AudioPlayer";

function EmbedPage() {
    return (
        <AudioPlayer backendUrl="/api" />
    )
}

export default EmbedPage;